import BucketView from "./BucketView";

export default BucketView;
